import { Link } from 'react-router-dom';
import type { ContentItem } from '@/types/content';
import ContentCard from '@/components/base/ContentCard';
import SectionTitle from '@/components/base/SectionTitle';
import { formatViews, getDetailPath } from '@/utils/content';

interface NewsSpotlightProps {
  items: ContentItem[];
}

export default function NewsSpotlight({ items }: NewsSpotlightProps) {
  const [lead, ...rest] = items;
  if (!lead) return null;

  return (
    <section className="mx-auto mt-10 max-w-[1440px] px-4 md:mt-14 md:px-6">
      <SectionTitle
        title="新闻精选"
        subtitle="权威及时 · 洞察时事动态"
        icon="ri-newspaper-line"
        moreTo="/category/news"
      />
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <Link
          to={getDetailPath(lead)}
          className="group relative flex h-72 flex-col justify-end overflow-hidden rounded-xl md:h-full md:min-h-[384px]"
        >
          <img
            src={lead.image}
            alt={lead.title}
            title={lead.title}
            className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/90 via-secondary-950/45 to-transparent"></div>
          <div className="relative p-5 md:p-7">
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              {lead.subCategory}
            </span>
            <h3 className="mt-3 line-clamp-2 font-heading text-xl font-bold text-background-50 md:text-2xl">
              {lead.title}
            </h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-background-200">{lead.summary}</p>
            <div className="mt-3 flex items-center gap-4 text-xs text-background-300">
              <span>{lead.publishTime.slice(0, 10)}</span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {formatViews(lead.views)}
              </span>
            </div>
          </div>
        </Link>

        <div className="flex flex-col gap-3">
          {rest.slice(0, 3).map((item) => (
            <ContentCard key={item.id} item={item} layout="horizontal" />
          ))}
        </div>
      </div>
    </section>
  );
}